import React, { useState, useEffect } from "react";
import {
    Box,
    Paper,
    Typography,
    Tabs,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Chip,
    Button,
    TextField,
    CircularProgress,
} from "@mui/material";

import { Link } from "react-router-dom";
import { getAllOrders } from "../../services/orderService";
import { getOrderStatusLabelPt, getOrderStatusColor, isFinalOrderStatus, normalizeOrderStatus } from "../../utils/orderStatus";

export default function Orders() {
    const [tab, setTab] = useState(0);
    const [search, setSearch] = useState("");
    const [pedidos, setPedidos] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        carregarPedidos();
    }, []);

    async function carregarPedidos() {
        try {
            const orders = await getAllOrders();
            setPedidos(orders);
        } catch (err) {
            console.error("Erro ao carregar pedidos:", err);
        } finally {
            setLoading(false);
        }
    }

    function formatDate(timestamp) {
        if (!timestamp) return "Data inválida";
        const date = new Date(timestamp);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        return `${day}/${month}/${year} (${hours}:${minutes})`;
    }

    function getPaymentMethod(payment) {
        if (!payment || !payment.method) return "N/A";
        return payment.method === "card" ? "Cartão de crédito" : "PIX";
    }

    const pedidosFiltrados = pedidos
        .filter((p) => {
            const s = normalizeOrderStatus(p.status);
            return tab === 0 ? !isFinalOrderStatus(s) : isFinalOrderStatus(s);
        })
        .filter(p =>
            p.id?.toLowerCase().includes(search.toLowerCase()) ||
            getPaymentMethod(p.payment).toLowerCase().includes(search.toLowerCase()) ||
            p.client?.name?.toLowerCase().includes(search.toLowerCase())
        )
        .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));

    if (loading) {
        return (
            <Box sx={{ p: 4, ml: 32, display: "flex", justifyContent: "center", alignItems: "center", minHeight: "400px" }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box sx={{ p: 4, ml: 32 }}>
            {/* Cabeçalho */}
            <Typography variant="h4" sx={{ fontWeight: 700, mb: 3 }}>
                Pedidos
            </Typography>

            {/* Tabs + Busca */}
            <Paper
                sx={{
                    mb: 3,
                    borderRadius: 3,
                    px: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}
            >
                <Tabs
                    value={tab}
                    onChange={(e, newValue) => setTab(newValue)}
                    indicatorColor="primary"
                    textColor="var(--cinza)"
                >
                    <Tab label="Em andamento" />
                    <Tab label="Finalizados" />
                </Tabs>

                <TextField
                    size="small"
                    placeholder="Buscar pedido..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    sx={{ width: 260 }}
                />
            </Paper>

            {/* Tabela */}
            <Paper sx={{ p: 2, borderRadius: 3 }}>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>ID</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Pagamento</TableCell>
                                <TableCell>Data</TableCell>
                                <TableCell>Valor</TableCell>
                                <TableCell align="right">Ações</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {pedidosFiltrados.map((pedido) => (
                                <TableRow key={pedido.id} hover>
                                    <TableCell sx={{ fontWeight: 600 }}>
                                        {pedido.id}
                                    </TableCell>

                                    <TableCell>
                                        <Chip
                                            label={getOrderStatusLabelPt(pedido.status)}
                                            color={getOrderStatusColor(pedido.status)}
                                            size="small"
                                        />
                                    </TableCell>

                                    <TableCell>{getPaymentMethod(pedido.payment)}</TableCell>

                                    <TableCell>{formatDate(pedido.createdAt)}</TableCell>

                                    <TableCell sx={{ fontWeight: 600 }}>
                                        R$ {pedido.total?.toFixed(2) || "0.00"}
                                    </TableCell>

                                    <TableCell align="right">
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            component={Link}
                                            to={`/admin/pedidos/${pedido.id}`}
                                        >
                                            Acessar pedido
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}

                            {pedidosFiltrados.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={6}>
                                        <Typography align="center" sx={{ py: 3 }}>
                                            Nenhum pedido encontrado.
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Box>
    );
}